import { useCallback, useState } from 'react';
import { ApiError, useCallApi } from './common';
import { TypingApi, TypingGetWordResponse, TypingWord } from '../../api';

export const useTypingWords = () => {
  const [error, setError] = useState<ApiError | null>(null);
  const { callApi, defaultConfiguration } = useCallApi();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [typingWords, setTypingWords] = useState<TypingWord[] | undefined>(undefined);

  const getTypingWords = useCallback(
    async (gradeId: number) => {
      setIsLoading(true);
      setError(null);
      const api = new TypingApi(await defaultConfiguration());
      try {
        const response = await callApi<TypingGetWordResponse, null>(null, () => api.apiV1TypingWordsGet(gradeId));

        if (response.error) {
          setTypingWords([]);
          setError(response.error);
        }
        if (response.success) {
          setTypingWords(response.success.data);
          return response.success.data;
        }
      } finally {
        setIsLoading(false);
      }
    },
    [callApi, defaultConfiguration]
  );

  return {
    error,
    isLoading,
    getTypingWords,
    typingWords,
  };
};
